import {
  BsHubService,
  BsCacheService, SimpleGlobalModalService
} from '@brightside-web/desktop/data-access/core-services';
import { Subscription } from 'rxjs';
import {Component, inject, Injectable, OnDestroy, OnInit} from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { RoutingStateService } from '@brightside/brightside-ui-services';
import {
  FirebaseService,
  isTemplateFullScreen
} from '@brightside-web/desktop/data-access/shared';
import { Environment } from '@brightside-web/micro/core/environment';
import { CreditSetupService } from '@brightside-web/desktop/data-access/credit';

/**
 * VerifyKba and VerifyOTP shared a LOT of code.
 */
@Injectable()
export class AbstractCreditSetupComponent implements OnDestroy, OnInit {

  bsHubService: BsHubService = inject(BsHubService);
  bsCacheService: BsCacheService = inject(BsCacheService);
  _router: Router = inject(Router);
  creditSetupSvc = inject(CreditSetupService);
  _modalService = inject(SimpleGlobalModalService);

  protected sub = new Subscription();
  processing = false;
  pageOnBackCtaPath = [];
  pageOnForwardCtaPath = [];
  pageFromFullLayout = false;
  brightsideWebFbBase = { event_name: 'credit_setup' };

  constructor(
    protected router: Router,
    protected routingState: RoutingStateService,
    protected activatedRoute: ActivatedRoute,
    protected env: Environment,
    protected analytics: FirebaseService,
  ) {}

  ngOnInit() {
    this.setUpHub();
    if (isTemplateFullScreen(this.activatedRoute)) {
      this.pageFromFullLayout = true;
    }
  }

  protected async completeRoute(): Promise<string[]> {
    const onboarding = await this.bsCacheService.getItem('ONBOARDING_FLOW_ACTIVE');
    if (onboarding) {
      const campaign = await this.bsCacheService.getItem('CREDIT_CAMPAIGN');
      if (campaign && campaign.analytics) {
        if (!this.env.production) {
          console.log(`FIREBASE: v4: 3 ${campaign.analytics.completed}`);
        }
        if (campaign.analytics.completed) {
          this.analytics.logEvent(campaign.analytics.completed);
        }
        this.bsCacheService.removeItem('CREDIT_CAMPAIGN');
      }

      this._modalService.createModal({
        title: 'ONBOARDING_CREDIT_VERIFIED_SUCCESS_TITLE',
        contentKey: 'ONBOARDING_CREDIT_VERIFIED_SUCCESS_DESC',
        headerImagePath: './assets/thumbs-up.png',
        displayCloseButton: false,
        eventName: 'onboarding_credit_completed',
        isError: false,
        size: 'medium',
        ctaKey: 'BUTTON_CONTINUE',
        ctaAction: () => {
          this.creditSetupSvc.creditSucceeded.set(true);
        },
      });

      return ['onboarding'];
    } else {
      return ['credit-setup', 'complete'];
    }
  }

  ngOnDestroy() {
    console.log(`destroying sub resources`);
    this.sub.unsubscribe();
  }

  protected setUpHub() {
    this.bsHubService.listen('ErrorChannel', () => {});
  }

  protected handleRouteForward(popHistory?: boolean, overrideRoute?: string[]) {
    const routeHere = overrideRoute || this.pageOnForwardCtaPath;
    this.handleRoute(popHistory || false, routeHere);
  }

  protected handleRoute(popHistory: boolean, routeHere: string[], options: any = {}) {
    if (popHistory) {
      this.routingState.popAndNavigateTo(routeHere, options);
    } else {
      this.router.navigate(routeHere, options);
    }
  }

  getFbInfo(extendWith?: any) {
    return { ...this.brightsideWebFbBase, ...extendWith };
  }
}
